import { render, staticRenderFns } from "./CatalogPet.vue?vue&type=template&id=dc5fce6c&scoped=true&"
import script from "./CatalogPet.vue?vue&type=script&lang=js&"
export * from "./CatalogPet.vue?vue&type=script&lang=js&"
import style0 from "./CatalogPet.vue?vue&type=style&index=0&id=dc5fce6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5fce6c",
  null
  
)

export default component.exports